<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox1" style="margin-left:-20px;">
            <div class="item">
              <el-form-item label="提单号:" prop="demandNo">
                <el-input placeholder="" v-model="searchFrom.demandNo"></el-input>
              </el-form-item>
              <el-form-item label="竞价状态:" prop="status">
                <el-select v-model="searchFrom.status" placeholder="请选择">
                  <el-option v-for="val in options" :label="val.name" :value="val.id" :key="val.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                <!-- <el-form-item>
                  <el-button type="primary" @click="addClick">新增</el-button>
                </el-form-item> -->
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="addClick(scope.row)" v-if="(scope.row.status == '1101' || scope.row.status == '1002' || scope.row.status == '1102') &&  btnFlg[0]">作废</el-button>
              <el-button type="text" size="mini" @click="resultFn(scope.row)"  v-if="(scope.row.status == '1203' || scope.row.status == '1301') &&  btnFlg[1]">结果</el-button>
              <el-button type="text" size="mini" @click="priceParityFn(scope.row)" v-if="(scope.row.status == '1102' || (scope.row.status == '1101' && scope.row.priceParityShowFlag == 0)) && btnFlg[2]">比价</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="提货单号" width="240">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.demandNo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status"  min-width="120" :formatter="statusFormat" label="竞价状态"></el-table-column>
        <el-table-column prop="demandFinalDate"  min-width="170" :formatter="(row, column,cellValue,index) => dateTimeFormat(row, column,cellValue,index, 1)" label="竞价截止时间"></el-table-column>
        <el-table-column prop="productTypeName"  min-width="220" :formatter="emptyFn" label="货物类型" show-overflow-tooltip></el-table-column>
        <el-table-column label="委托量" width="160">
          <template slot-scope="scope">
            <div>
              {{scope.row.productWeight}} 吨 / {{scope.row.productNum}} 件
            </div>
          </template>
        </el-table-column>
        <el-table-column label="实提量" width="160">
          <template slot-scope="scope">
            <div>
              {{scope.row.actualWeight}} 吨 / {{scope.row.actualNum}} 件
            </div>
          </template>
        </el-table-column>
        <el-table-column label="限价区间" width="180">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.pricingMethod == 1">{{scope.row.lowPrice}} 元/吨 ~ {{scope.row.highPrice}} 元/吨</span>
              <span v-if="scope.row.pricingMethod == 2">{{scope.row.lowPrice}} 元 ~ {{scope.row.highPrice}} 元</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="carriageName"  min-width="170" :formatter="emptyFn" label="承运方"></el-table-column>
        <el-table-column label="发货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#0c46a2">(发){{scope.row.deliverCompany}}</span>
              <span>{{scope.row.deliverPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.deliverPhone}}  </span>
              <span style="margin-left:10px">{{scope.row.deliverAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#F56C6C">(收){{scope.row.receivingCompany}}</span>
              <span>{{scope.row.receivingPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.receivingPhone}}</span>
              <span style="margin-left:10px">{{scope.row.receivingAddress}}</span>
            </div>
          </template>
        </el-table-column>
       <el-table-column prop="hopeReceivingDate"  min-width="170" :formatter="(row, column,cellValue,index) => dateTimeFormat(row, column,cellValue,index, 1)" label="最晚提货时间"></el-table-column>
       <el-table-column prop="createUserName"  min-width="130" :formatter="emptyFn" label="创建人" show-overflow-tooltip></el-table-column>
       <el-table-column prop="createTime"  min-width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <el-dialog :title="title"  :visible.sync="SQMark" width="450px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQFrom" ref="SQFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="145px" size="mini">
        <div class="inpBox1">
          <div style="margin: 28px 0;">
            <el-form-item label="作废原因:" prop="abandonedReason" style="margin-top:10px;">
              <el-input type="textarea" v-model="SQFrom.abandonedReason"></el-input>
            </el-form-item>
          </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SQMark = false">取消</el-button>
        <el-button type="primary" @click="SQsave()" v-show="addBtnShow">确定</el-button>
        <el-button type="primary" @click="editSave()" v-show="editBtnShow">修改</el-button>
      </span>
   </el-dialog>
    <el-dialog  title="查看结果"  :close-on-click-modal="false" :close-on-press-escape="false"  :visible.sync="isEdit" @close="closeDialog" width="1100px" center>
        <div>
           <div class="spry">
              <div style="margin: 20px 0;display: flex;justify-content: space-between">
               <div>
                  成交承运商：{{result.carriageName}}
               </div>
               <div>
                  成交时间：{{dateFormatUtil('yyyy-MM-dd hh:ii', result.completeTime)}}
               </div>
              </div>
              <div class="tbox">
                <el-table :data="sDemandOfferList" border ref="CDtable" highlight-current-row  max-height="350px" >
                  <el-table-column type="index" prop="date" width="55" :reserve-selection="true" label="序号"></el-table-column>
                  <el-table-column property="pricingMethod" label="报价方式"  width="150px">
                    <template scope="scope">{{[ "单价", "包干" ][scope.row.pricingMethod-1]}}</template>
                  </el-table-column>
                  <el-table-column prop="offerPrice" min-width="130px" :formatter="emptyFn" label="成交报价" show-overflow-tooltip>
                    <template scope="scope">
                      <div>
                        <span v-if="scope.row.pricingMethod == 1">{{scope.row.offerPrice}} 元/吨</span>
                        <span v-if="scope.row.pricingMethod == 2">{{scope.row.offerPrice}} 元</span>
                      </div>
                    </template>
                    </el-table-column>
                  <el-table-column prop="dealPrice"  min-width="130px" :formatter="emptyFn" label="运费(元)"></el-table-column>
                  <el-table-column prop="serviceFee"  min-width="130px" :formatter="emptyFn" label="找车服务费(含税/元)"></el-table-column>
                  <el-table-column prop="incidental"  min-width="130px" :formatter="emptyFn" label="杂费(元)"></el-table-column>
                  <el-table-column min-width="130px" :formatter="emptyFn" label="合计(元)">
                    <template scope="scope">
                      <div>
                        {{Number(toFixed(parseFloat(scope.row.dealPrice) + parseFloat(scope.row.serviceFee) + (scope.row.incidental ? parseFloat(scope.row.incidental) : 0), 2))}}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isEdit = false" type='primary'>关闭</el-button>
        </span>
    </el-dialog>
     <!-- 选择车队 -->
    <el-dialog  title="比价"  :close-on-click-modal="false" :close-on-press-escape="false"  :visible.sync="priceFn" @close="closeDialog" width="1100px" center>
        <div>
           <div class="spry">
              <div class="tbox">
                <el-table :data="priceList" border ref="CDtable" highlight-current-row max-height="350px" @current-change="handleSelectionChange">
                  <!-- <el-table-column type="selection" @click="handleCurrentChange1(scope.row)" width="55"></el-table-column> -->
                  <el-table-column type="index" prop="date" width="55" :reserve-selection="true" label="序号"></el-table-column>
                  <el-table-column prop="carriageName" min-width="190px" :formatter="emptyFn" label="承运商名称" show-overflow-tooltip></el-table-column>
                  <el-table-column property="pricingMethod" label="报价方式"  width="150px">
                    <template scope="scope">{{[ "单价", "包干" ][scope.row.pricingMethod-1]}}</template>
                  </el-table-column>
                  <el-table-column prop="offerPrice"  width="120px" :formatter="emptyFn" label="单价">
                    <template scope="scope">
                      <div  v-if="scope.row.pricingMethod==1">
                        {{scope.row.offerPrice}} 元/吨
                      </div>
                      <div v-else>
                        {{scope.row.offerPrice}} 元
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column width="120px" :formatter="emptyFn" label="总价(元)">
                    <template scope="scope">
                      <div  v-if="scope.row.pricingMethod==1">
                        {{Number(toFixed(parseFloat(scope.row.offerPrice) * parseFloat(scope.row.productWeight), 2))}}
                      </div>
                      <div v-else>
                         {{scope.row.offerPrice}}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="dealTime"  min-width="300px" :formatter="dateTimeFormat" label="报价时间" show-overflow-tooltip></el-table-column>
                </el-table>

              </div>
          </div>
          <div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="priceFn = false">取消</el-button>
          <el-button type="primary" @click="GJFN()">指派</el-button>
        </span>
        </el-dialog>
 </div>
</template>

<script>
import { getBtn, getAttribute, getAttributeA } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat, toFixed, dateFormatUtil } from '@/utils/util'
import {
  sModuleDelete // 删除
} from '@/api/newCrm'
import { biddingDemandList, cancelDemand, showBiddingResult, getDemandOfferListByDemandId, doBiding, cancelFindCarTypeEmptyBill } from '@/api/soc-stock'
export default {
  data () {
    return {
      dateFormatUtil: dateFormatUtil,
      toFixed: toFixed,
      priceList: [],
      priceFn: false,
      result: {},
      sDemandOfferList: [],
      isEdit: false,
      options: [
        { name: '待竞价', id: '1002' },
        { name: '竞价中', id: '1101' },
        { name: '待比价', id: '1102' },
        { name: '竞价成功', id: '1203' },
        { name: '竞价失败', id: '1202' },
        { name: '已作废', id: '1201' },
        { name: '审核中', id: '1000' },
        { name: '已派车', id: '1301' }
      ],
      title: '',
      addBtnShow: false,
      editBtnShow: false,
      SQFrom: {
      },
      SQMark: false,
      rules: {
        abandonedReason: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ],
        clientClassify: [
          { required: true, message: '请选择客户端类型', trigger: 'blur' }
        ]
      },
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      btnFlg: [],
      btnIdArr: ['00UM090100', '00UM090200', '00UM090300'],
      multipleSelection: {},
      tableArr: [],
      janFaFlag: null
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/searchCarJY')
    this.tableArr = getAttribute('ARRoneCustomerName,ARRownerCustomerName,ARRisCarHold,ARRvalidityTime,ARRdriverIdentityNo')
    this.warehouseList = [{
      relTenantName: localStorage.getItem('createTenantName'),
      relTenantCode: localStorage.getItem('createTenantCode')
    }]
    this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
    getAttributeA('ARRisSelfWarehouse', this.warehouseList[0].relTenantCode).then(res => {
      console.log(res)
      if (res[0] == 3) { // 是建发库
        this.janFaFlag = 1
      }
      this.getList(this.searchFrom)
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 状态格式化
    statusFormat (row, column, cellValue) {
      console.log(cellValue)
      switch (cellValue) {
        case 1002:
          return '待竞价'
        case 1101:
          return '竞价中'
        case 1102:
          return '待比价'
        case 1203:
          return '竞价成功'
        case 1202:
          return '竞价失败'
        case 1201:
          return '已作废'
        case 1000:
          return '审核中'
        case 1301:
          return '已派车'
      }
    },
    priceParityFn (row) {
      this.priceFn = true
      getDemandOfferListByDemandId({ demandId: row.id }).then(res => {
        console.log(res)
        this.priceList = res

        // this.sDemandOfferList = [res]
        // console.log(this.sDemandOfferList)
        // console.log(this.sDemandOfferList[0].carriageName)
        // this.$set(this.result, 'carriageName', this.sDemandOfferList[0].carriageName)
      }).catch(error => {
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    handleSelectionChange (val) {
      console.log(val, '000')
      this.multipleSelection = val
      let a = Number(toFixed(parseFloat(this.multipleSelection.offerPrice) * parseFloat(this.multipleSelection.productWeight), 2))
      console.log(a)
      this.$set(this.multipleSelection, 'dealPrice', a)
      // let addform = {
      //   demandId: this.multipleSelection[0].demandId,
      //   demandOfferId: this.multipleSelection[0].demandOfferId,
      //   offerPrice: this.multipleSelection[0].offerPrice,
      //   dealPrice: a
      // }
    },
    GJFN () {
      if (Object.keys(this.multipleSelection).length == 0) {
        this.$alert('请选择承运商信息!', '系统提示')
        return
      }
      let addform = {
        demandId: this.multipleSelection.demandId,
        demandOfferId: this.multipleSelection.demandOfferId,
        offerPrice: this.multipleSelection.offerPrice,
        dealPrice: this.multipleSelection.dealPrice
      }
      doBiding(addform).then(res => {
        this.$message({
          message: '比价成功',
          type: 'success'
        })
        this.priceFn = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    resultFn (row) {
      showBiddingResult({ demandId: row.id, offerFlag: 0 }).then(res => {
        this.isEdit = true
        console.log(res)
        this.sDemandOfferList = [res]
        console.log(this.sDemandOfferList)
        console.log(this.sDemandOfferList[0].carriageName)
        this.$set(this.result, 'carriageName', this.sDemandOfferList[0].carriageName)
        this.$set(this.result, 'completeTime', this.sDemandOfferList[0].completeTime)
      }).catch(error => {
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    // 详情
    // detailFn (row) {
    //   this.$router.push({ name: 'MlookGoodsDetails', query: { id: row.demandId, status: row.demandOfferStatus } })
    // },
    detailFn (row) {
      this.$router.push({ name: 'detailsALL', query: { id: row.id } })
    },
    // 添加
    addClick (row) {
      this.title = '作废'
      this.addBtnShow = true
      this.editBtnShow = false
      this.SQMark = true
      // this.SQFrom.id = row.id
      this.SQFrom.billNo = row.demandNo
      // this.SQFrom.abandonedReason = row.remark
    },
    SQsave () {
      this.$refs.SQFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cancelFindCarTypeEmptyBill(this.SQFrom).then(res => {
            loading.close()
            this.$message({
              message: '作废成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 修改
    editFn (row) {
      this.title = '修改模块'
      this.addBtnShow = false
      this.editBtnShow = true
      this.SQMark = true
      this.SQFrom = {
        id: row.id,
        name: row.name,
        remark: row.remark,
        clientClassify: row.clientClassify
      }
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sModuleDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      biddingDemandList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(error => {
        this.loading = false
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      // this.$refs['SQFrom'].clearValidate()
      this.SQFrom = {
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox1 .el-date-editor{
  width: 350px!important;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
/deep/.inpBox1 .el-input__inner {
    width: 180px;
}
</style>
